import { render, staticRenderFns } from "./StrokeArrowIcon.vue?vue&type=template&id=bc5bb3aa&scoped=true"
import script from "./StrokeArrowIcon.vue?vue&type=script&lang=js"
export * from "./StrokeArrowIcon.vue?vue&type=script&lang=js"
import style0 from "./StrokeArrowIcon.vue?vue&type=style&index=0&id=bc5bb3aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5bb3aa",
  null
  
)

export default component.exports